// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"clipPath":"url(#clip0_101749_96872)"},"nodeName":"g","children":[{"attributes":{"fill":"currentColor","d":"M22.234 18L6.23404 2H22.5V18H22.234Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23.4101 22.0045L22.0002 23.4144L16.5858 18H6.87574L1.5 22.7038V2.91421L0.585938 2.00015L2.00015 0.585938L2.0043 0.590088L2 0.594389L23.4101 22.0045Z"},"nodeName":"path","children":[]}]}]};

@tag('t-icon-chat-off-filled')
export default class ChatOffFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chat-off-filled',
    }
  }
}
